import { getStorefrontGoogleMapsApiKey } from '../../modules/storefront/exports/Cookies';

const useEnv = () => {
  return {
    ...import.meta.env,
    VITE_GOOGLE_MAPS_API_KEY: getStorefrontGoogleMapsApiKey() ?? import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  };
};

export default useEnv;
